export default "__VITE_ASSET__BkaV7Q8x__"